import O1HD from "../../../../engines/gameEngine";
import ChickenPrefab from "./ChickenPrefab";
import NormalGameManager from "../../manager/NormalGameManager";
import utilsModel from "../../../../engines/libs/utilsModel";

const {ccclass, property} = cc._decorator;

/**
 *
 */
@ccclass
export default class ChickenEnlargeCapacity extends cc.Component {

    private mParentScript : ChickenPrefab;

    onLoad () {}

    start () {

    }

    bindData( parentScript : ChickenPrefab ){
        this.mParentScript = parentScript;
    }

    onBtnCancel(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.mParentScript.enlargeCapacityFlag = true;
        this.node.removeFromParent();
        this.node.destroy();
    }

    onBtnUnLock(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if ( NormalGameManager._instance.getGameData().chickenCoop.capacity >= 20 ) {
            O1HD.getModules().uiControlModule.showMessageBox("已是最大容量");
            return;
        }
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.mParentScript.enlargeCapacity();
            this.mParentScript.enlargeCapacityFlag = true;
            this.node.removeFromParent();
            this.node.destroy();
        },()=>{

        },()=>{

        },"鸡场扩容");
    }
}
